/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as transactionService from '../../../services/transactionService'
class DashboardDetailsModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
         detailsData: null,
         amount: null,
         remark: "",
         mpassword: "",
         toastMsg: "",
         toastType: "",
         loader: true,
      };
   }
   componentDidMount() {
      this.getDetails();
   }

   getDetails() {
      const self = this;
      let body = {
         filter_date_point: this.props.dataOf.range
      }
      transactionService.dashboardDepoWithDetails(this.props.dataOf.type, body).then((res) => {
         if (res.isSuccess) {
            self.setState({
               detailsData: res.items,
               loader: false
            })
         } else {
            self.props.notify(res?.exception?.message, "error");
            self.setState({
               loader: false
            })
         }
      })
   }

   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   render() {
      const dic = {
         'today': 'Today',
         'yesterday': 'Yesterday',
         'thisWeek': 'This Week',
         'lastWeek': 'Last Week',
         'thisMonth': 'This Month',
         'lastMonth': 'Last Month'
      }
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="mydeposit" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">{dic[this.props.dataOf.range]} {this.props.dataOf.type === 'firstDeposit' ? 'First Deposit' : this.props.dataOf.type === 'register' ? 'Registered Users' : this.props.dataOf.type === 'depo' ? 'Deposit' : 'Withdrawal'}</h4>
                        <button type="button" className="close text-white" onClick={() => { this.props.closePopup() }} data-dismiss="modal">×</button>
                     </div>
                     <div className="modal-body lst-pop ">
                        <div>
                           <table className="table font-12 table-bordered table-sm addpadding table-striped mt-0 mb-0">
                              <thead className="thead-light">
                                 <tr>
                                    <th>Sr.</th>
                                    <th>User</th>
                                    <th>Amount</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {
                                    this.state.loader ?
                                       <tr>
                                          <td colSpan={3}>
                                             Loading......
                                          </td>
                                       </tr>
                                       :

                                       <>
                                          {
                                             !!this.state.detailsData && this.state.detailsData.map((itm, i) => {
                                                return (
                                                   <tr key={`dtl_${i}`}>
                                                      <td>{i + 1}</td>
                                                      <td>{itm[(this.props.dataOf.type === 'firstDeposit' || this.props.dataOf.type === 'register') ? 'username' : this.props.dataOf.type === 'depo' ? 'creditAccount' : 'debitAccount']}</td>
                                                      <td>{itm[(this.props.dataOf.type === 'firstDeposit' || this.props.dataOf.type === 'register') ? 'firstDepositAmount' : 'amount']}</td>
                                                   </tr>
                                                )
                                             })
                                          }
                                       </>
                                 }


                              </tbody>
                           </table>
                        </div>
                     </div>
                     <div className="modal-footer">

                        <a className="pop-edit-btn" tabIndex={5} style={{ cursor: "pointer" }} onClick={() => { this.props.closePopup() }} data-dismiss="modal">Cancel</a>
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
            </div>
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(DashboardDetailsModel);